export default "__VITE_ASSET__CsHbgrsC__"